import { ta } from "../../../../date-fns/locale/ta.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ta
  }
};